import { useEffect, useState } from "react";
import SoftBox from "src/components/SoftBox";
import SoftTypography from "src/components/SoftTypography";
import { Select, Option } from "src/components/SoftMultiSelect";
import Checkbox from "@mui/material/Checkbox";

function CalendarFilter({
  label,
  placeholder,
  defaultValues,
  options,
  onChange,
}: {
  label: string;
  placeholder: string;
  defaultValues: { id: string; title: string; [key: string]: any }[];
  options: { id: string; title: string; [key: string]: any }[];
  onChange: (value: any[]) => void;
}) {
  const [selectedOptions, setSelectedOptions] = useState<any[] | null>(
    options.filter((option) =>
      defaultValues.some((value) => value.id === option.id)
    )
  );

  useEffect(() => {
    setSelectedOptions(
      options.filter((option) =>
        defaultValues.some((value) => value.id === option.id)
      )
    );
  }, [defaultValues, options]);

  return (
    <SoftBox px={1}>
      {label && (
        <SoftBox mb={1} ml={0.5}>
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {label}
          </SoftTypography>
        </SoftBox>
      )}
      {selectedOptions && (
        <Select
          // labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={selectedOptions}
          onChange={(event, newValue) => {
            if (newValue?.includes("selectAll")) {
              setSelectedOptions(
                selectedOptions.length < options.length ? options : []
              );
              onChange(selectedOptions.length < options.length ? options : []);
            } else if (event && Array.isArray(newValue)) {
              setSelectedOptions(newValue ?? []);
              onChange(
                newValue.sort((a: any, b: any) =>
                  a.type === "Simulators" || b.type === "Simulators"
                    ? 0
                    : a.payload.index - b.payload.index
                ) ?? []
              );
            }
          }}
          renderValue={(selected: any) => {
            if (selected?.length > 0) {
              return selected.length === options.length
                ? placeholder ?? "All"
                : `${selected?.length} Selected`; // selected?.map((s) => s.label).join(", ")
            } else {
              return "None Selected";
            }
          }}
        >
          <Option key={"selectAll"} value={"selectAll"}>
            <SoftBox sx={{ display: "flex" }}>
              <SoftTypography
                variant="body2"
                color="primary"
                sx={{ width: "100%", textAlign: "center" }}
              >
                {selectedOptions.length < options.length
                  ? "Select All"
                  : "Deselect All"}
              </SoftTypography>
            </SoftBox>
          </Option>
          {options.map((option) => (
            <Option key={option.id} value={option}>
              <SoftBox sx={{ display: "flex" }}>
                <Checkbox
                  checked={selectedOptions?.some(
                    (selected) => selected.id === option.id
                  )}
                />
                <SoftTypography variant="body2">{option.title}</SoftTypography>
              </SoftBox>
            </Option>
          ))}
        </Select>
      )}
    </SoftBox>
  );
}

export default CalendarFilter;
